import {
  GroupLocator,
  TeamsMeetingLinkLocator,
} from "@azure/communication-calling";
import { CommunicationUserIdentifier } from "@azure/communication-common";
import React, { useEffect, useState } from "react";
import { initializeIcons, Spinner } from "@fluentui/react";
import { CallError } from "../views/CallError";
import { CallScreen } from "../views/CallScreen";
import Login from "./Login";
import { navigateToHomePage } from "../utils/AppUtils";
import { TokenService } from "../services/token.service";
import { useGlobalState } from "../utils/GlobalState";

initializeIcons();

type AppPages = "login" | "call" | "endCall";

const webAppTitle = document.title;

const ACSHelper = (): JSX.Element => {
  const [page, setPage] = useState<AppPages>("call");

  // User credentials to join a call with - these are retrieved from the server

  const [token, setToken] = useState<string>();
  const [userId, setUserId] = useState<CommunicationUserIdentifier>();
  const [userCredentialFetchError, setUserCredentialFetchError] =
    useState<boolean>(false);

  // Call details to join a call - these are collected from the user on the home screen
  const [callLocator, setCallLocator] = useState<
    GroupLocator | TeamsMeetingLinkLocator
  >();
  const [groupCallLocator, setGroupCallLocator] = useState<GroupLocator>();
  const [displayName, setDisplayName] = useState<string>("Student");
  const tokenService = new TokenService();
  const { state } = useGlobalState();
  const accessToken: string | null = localStorage.getItem("accessToken");

  useEffect(() => {
    (async () => {
      try {
        tokenService
          .fetchTokenResponse(accessToken)
          .then((response) => {
            setToken(response.accessToken.token);
            setUserId({ communicationUserId: response.user.id });
          })
          .catch((error) => {
            console.error(error);
            setUserCredentialFetchError(true);
          });

        setGroupCallLocator(groupCallLocator);
        setCallLocator({ groupId: state.meetingId! });
      } catch (e) {
        console.error(e);
        setUserCredentialFetchError(true);
      }

      setDisplayName(`Student ${state.studentId!}`);
    })();
  }, []);

  switch (page) {
    case "login": {
      return <Login />;
    }
    case "call": {
      if (userCredentialFetchError) {
        document.title = `error - ${webAppTitle}`;
        return (
          <CallError
            title="Error getting user credentials from server"
            reason="Ensure the server is running."
            rejoinHandler={() => setPage("call")}
            homeHandler={navigateToHomePage}
          />
        );
      }

      if (!token || !userId || !displayName || !callLocator) {
        document.title = `credentials - ${webAppTitle}`;
        return (
          <Spinner
            label={"Getting user credentials from server"}
            ariaLive="assertive"
            labelPosition="top"
          />
        );
      }
      return (
        <CallScreen
          token={token}
          userId={userId}
          groupId={state.meetingId!}
          displayName={displayName}
          callLocator={callLocator}
          onCallEnded={() => setPage("login")}
          webAppTitle={webAppTitle}
        />
      );
    }
    default:
      document.title = `error - ${webAppTitle}`;
      return <>Invalid page</>;
  }
};

export default ACSHelper;
